// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cdk-overlay-pane {
  max-width: 90vw !important;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container {
  border-radius: 16px !important;
  overflow: hidden !important;
  padding: 0 !important;
}
::ng-deep .cdk-overlay-pane .mdc-dialog__container {
  border-radius: 16px !important;
  overflow: hidden !important;
}
::ng-deep .cdk-overlay-pane .mdc-dialog__surface {
  border-radius: 16px !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.error-dialog-container {
  display: flex;
  flex-direction: column;
  min-width: 360px;
  max-width: 480px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
@media (max-width: 600px) {
  .error-dialog-container {
    min-width: unset;
    width: 100%;
  }
}

.error-dialog-header {
  cursor: move;
}
.error-dialog-header .error-dialog-header-left {
  position: relative;
  z-index: 1;
  min-width: 0;
}
.error-dialog-header .header-close-btn {
  width: 30px !important;
  height: 30px !important;
  line-height: 30px !important;
  min-width: unset !important;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px !important;
  transition: background 0.15s, color 0.15s;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  z-index: 1;
}
.error-dialog-header .header-close-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 30px !important;
  height: 30px !important;
}
.error-dialog-header .header-close-btn mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 17px;
}
.error-dialog-header .header-close-btn:hover {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.error-dialog-body {
  padding: 20px 24px 8px;
  background: #ffffff;
}

.error-dialog-content {
  padding: 0 !important;
  max-height: unset !important;
  overflow: visible !important;
}

.error-dialog-actions {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 14px 24px 18px !important;
  border-top: 1px solid #e2e8f0;
  gap: 12px;
  background: #ffffff;
}
.error-dialog-actions button {
  min-width: 110px;
  height: 38px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  border-radius: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-component/ui-shared/error-dialog/error-dialog.component.scss"],"names":[],"mappings":"AAUA;EACI,0BAAA;AATJ;AAWI;EACI,8BAAA;EACA,2BAAA;EACA,qBAAA;AATR;AAYI;EACI,8BAAA;EACA,2BAAA;AAVR;AAaI;EACI,8BAAA;EACA,2BAAA;EACA,qBAAA;AAXR;;AAeA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBA/BM;EAgCN,mBA9BK;EA+BL,gBAAA;EACA,2CAAA;AAZJ;AAcI;EAVJ;IAWQ,gBAAA;IACA,WAAA;EAXN;AACF;;AAcA;EACI,YAAA;AAXJ;AAaI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AAXR;AAcI;EACI,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;EACA,6BAAA;EACA,yCAAA;EACA,qBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAAA;EACA,UAAA;AAZR;AAcQ;EACI,sBAAA;EACA,uBAAA;AAZZ;AAeQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAbZ;AAgBQ;EACI,qCAAA;EACA,WAAA;AAdZ;;AAmBA;EACI,sBAAA;EACA,mBAzFM;AAyEV;;AAmBA;EACI,qBAAA;EACA,4BAAA;EACA,4BAAA;AAhBJ;;AAmBA;EACI,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAzGM;AAyFV;AAkBI;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;AAhBR","sourcesContent":["// ==========================================================================\n// Component: Error-dialog.component\n// ==========================================================================\n\n$primary: #1a56db;\n$surface: #ffffff;\n$border: #e2e8f0;\n$radius: 16px;\n$radius-sm: 8px;\n\n::ng-deep .cdk-overlay-pane {\n    max-width: 90vw !important;\n\n    .mat-mdc-dialog-container {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n        padding: 0 !important;\n    }\n\n    .mdc-dialog__container {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n    }\n\n    .mdc-dialog__surface {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n        padding: 0 !important;\n    }\n}\n\n.error-dialog-container {\n    display: flex;\n    flex-direction: column;\n    min-width: 360px;\n    max-width: 480px;\n    background: $surface;\n    border-radius: $radius;\n    overflow: hidden;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, .15);\n\n    @media (max-width: 600px) {\n        min-width: unset;\n        width: 100%;\n    }\n}\n\n.error-dialog-header {\n    cursor: move;\n\n    .error-dialog-header-left {\n        position: relative;\n        z-index: 1;\n        min-width: 0;\n    }\n\n    .header-close-btn {\n        width: 30px !important;\n        height: 30px !important;\n        line-height: 30px !important;\n        min-width: unset !important;\n        flex-shrink: 0;\n        color: rgba(255, 255, 255, 0.75);\n        background: rgba(255, 255, 255, 0.1);\n        border-radius: 8px !important;\n        transition: background .15s, color .15s;\n        padding: 0 !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        position: relative;\n        z-index: 1;\n\n        ::ng-deep .mat-mdc-button-touch-target {\n            width: 30px !important;\n            height: 30px !important;\n        }\n\n        mat-icon {\n            font-size: 17px;\n            width: 17px;\n            height: 17px;\n            line-height: 17px;\n        }\n\n        &:hover {\n            background: rgba(255, 255, 255, 0.22);\n            color: #fff;\n        }\n    }\n}\n\n.error-dialog-body {\n    padding: 20px 24px 8px;\n    background: $surface;\n}\n\n.error-dialog-content {\n    padding: 0 !important;\n    max-height: unset !important;\n    overflow: visible !important;\n}\n\n.error-dialog-actions {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    padding: 14px 24px 18px !important;\n    border-top: 1px solid $border;\n    gap: 12px;\n    background: $surface;\n\n    button {\n        min-width: 110px;\n        height: 38px;\n        font-size: 13px;\n        font-weight: 600;\n        letter-spacing: .04em;\n        border-radius: $radius-sm !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
